<template>
  <section>
    <intro/>
    <picker />
  </section>
</template>

<script>
import Intro from '@/components/Intro.vue';
import Picker from '@/components/Picker.vue';

export default {
  components: {
    Intro,
    Picker
  }
}
</script>

<style lang="scss">
</style>
